import { Button, message, Select } from "antd";
import TextArea from "antd/lib/input/TextArea";
import {
  IIssueResData,
  IMenuOption,
  IPurchaseQueueMasterData,
  ISwimlaneInvoiceList,
} from "models/interfaces";
import React, { useEffect, useState } from "react";
import { PurchaseAndShippingService } from "services/SkyboxServices";
import { formatThousandSeparator } from "utils/commonFunction";

const swimlane_id = 7;

const CloseIssueShipping: React.FC<{
  menuData: IMenuOption;
  handleMenuSelection: Function;
  selectedMenuId: number | null;
  setSelectedMenuId: Function;
  eachInvoiceData: ISwimlaneInvoiceList;
  setShowMenu: Function;
  requestToReloadTheLanes: Function;
  purchaseQueueMaster: IPurchaseQueueMasterData | null;
}> = ({
  menuData,
  handleMenuSelection,
  selectedMenuId,
  setSelectedMenuId,
  eachInvoiceData,
  setShowMenu,
  requestToReloadTheLanes,
  purchaseQueueMaster,
}) => {
  const [issueResData, setIssueResData] = useState<IIssueResData>({
    invoice_id: eachInvoiceData.invoice_id,
    issue_resolution_reason_type: null,
    notes: null,
  });

  const [isValid, setIsValid] = useState(false);

  const issueResolutionReasonTypeChangeHandler = (value: string) => {
    if (value)
      setIssueResData((prev) => ({
        ...prev,
        issue_resolution_reason_type: parseInt(value),
      }));
  };
  const notesChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setIssueResData((prev) => ({
      ...prev,
      notes: e.currentTarget.value,
    }));
  };

  const cancelHandler = () => {
    setSelectedMenuId(null);
    setIssueResData((prev) => ({
      ...prev,
      issue_resolution_reason_type: null,
      notes: null,
    }));
  };

  const updateIssuesData = async () => {
    const updateIssueKey = "updateIssueKey";
    setSelectedMenuId(null);
    setShowMenu(false);
    message.loading({
      content: `Resolving issues with invoice...`,
      duration: 0,
      key: updateIssueKey,
      className: "toastMsg loadingMsg",
    });
    if (isValid) {
      const res = await new PurchaseAndShippingService().closeIssueShipping(issueResData);
      if (res.data.data) {
        setIsValid(false);
        message.success({
          content: `All issues have been resolved for invoice# ${eachInvoiceData.invoice_id}.`,
          duration: 5,
          key: updateIssueKey,
          className: "toastMsg savedSuccess",
        });
      } else {
        message.error({
          content: "Failed to close issue.",
          duration: 5,
          key: updateIssueKey,
          className: "toastMsg savedFailed",
        });
      }
      requestToReloadTheLanes([5, swimlane_id]);
    }
    setTimeout(() => {
      requestToReloadTheLanes(null);
    }, 3000);
  };

  useEffect(() => {
    if (
      issueResData?.issue_resolution_reason_type === null ||
      issueResData?.issue_resolution_reason_type === undefined
    ) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  }, [issueResData]);
  
  return (
    <React.Fragment>
      <div
        className="accHead"
        onClick={() => {
          if (selectedMenuId === menuData.menu_id) {
            handleMenuSelection(null);
          } else {
            handleMenuSelection(menuData.menu_id);
          }
        }}
      >
        {menuData.name}
      </div>
      <div className="accBody">
        <div className="moveOnSaleWrap">
          <div className="moveOnSaleRow">
            <Select
              defaultValue="Select"
              options={purchaseQueueMaster?.issueResolutionMasterData.filter((each) => each.value!==1 ).map(
                (each) => ({ ...each, value: each.value.toString() })
              )}
              getPopupContainer={(trigger) =>
                trigger.parentElement as HTMLInputElement
              }
              value={
                issueResData?.issue_resolution_reason_type
                  ? issueResData.issue_resolution_reason_type.toString()
                  : "Select"
              }
              onChange={issueResolutionReasonTypeChangeHandler}
            />
          </div>
          <div className="moveOnSaleRow">
            <TextArea
              placeholder="Note"
              className="moveToIssuesTxtArea"
              maxLength={1000}
              showCount={{
                formatter: ({ count, maxLength }) =>
                  maxLength
                    ? `${formatThousandSeparator(
                        (maxLength ?? 0) - count
                      )} Remaining`
                    : "",
              }}
              rows={4}
              value={issueResData?.notes ? issueResData.notes : ""}
              onChange={notesChangeHandler}
              allowClear
              autoSize={{ minRows: 4, maxRows: 4 }}
            />
          </div>
          <div className="moveOnSaleRow btnGroupFooter">
            <Button className="discardBtn" onClick={cancelHandler}>
              <span>CANCEL</span>
            </Button>
            <Button
              className="btnUpdate"
              disabled={!isValid}
              onClick={updateIssuesData}
            >
              Update
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CloseIssueShipping;
